import type { ImageWithAltType } from '~/types';

const generateImageAlt = (title: string, imageIndex: number) =>
  imageIndex ? `${title} - Photo ${imageIndex + 1}` : title;

export default (images: string[], title: string): ImageWithAltType[] =>
  images.map((src, index) => ({ src, alt: generateImageAlt(title, index) }));
